<template>
  <div class="section">
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <h1>Anuncios en App</h1>
        </div>
      </div>
      <div class="level-right pr-5">
        <div class="level-item">
          <button class="button button-givu" @click="openFormModal(null)">
            Nuevo anuncio
          </button>
        </div>
      </div>
    </nav>

    <div v-if="loading" class="has-text-centered py-6">
      <span>Cargando...</span>
    </div>

    <div v-else>
      <table class="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>Título</th>
            <th>Inicio</th>
            <th>Fin</th>
            <th>Estado</th>
            <th class="has-text-centered">Estadísticas</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="list.length === 0">
            <td colspan="6" class="has-text-centered">No hay anuncios creados</td>
          </tr>
          <tr v-for="item in list" :key="item.id">
            <td>{{ item.title }}</td>
            <td>{{ formatDate(item.start_date) }}</td>
            <td>{{ formatDate(item.end_date) }}</td>
            <td>
              <span class="tag" :class="item.is_active ? 'is-success' : 'is-light'">
                {{ item.is_active ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td class="has-text-centered">
              <button class="button is-small is-light" @click="openStatsModal(item)">
                <span class="icon is-small"><i class="material-icons" style="font-size:16px">bar_chart</i></span>
                <span>Ver stats</span>
              </button>
            </td>
            <td>
              <div class="buttons">
                <button class="button is-small is-info" @click="openFormModal(item)">Editar</button>
                <button
                  class="button is-small"
                  :class="item.is_active ? 'is-warning' : 'is-success'"
                  @click="handleToggleStatus(item.id)"
                >{{ item.is_active ? 'Desactivar' : 'Activar' }}</button>
                <button class="button is-small is-danger" @click="confirmDelete(item.id)">Eliminar</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <base-pagination :page="page" :pages="pages" :action="paginator" :loading="loading" />
    </div>

    <!-- ── MODAL FORMULARIO ─────────────────────────────── -->
    <div class="modal" :class="{ 'is-active': showFormModal }">
      <div class="modal-background" @click="closeFormModal" />
      <div class="modal-card announcement-modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ editingId ? 'Editar anuncio' : 'Nuevo anuncio' }}</p>
          <button class="delete" @click="closeFormModal" />
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Título *</label>
            <div class="control">
              <input v-model="form.title" class="input" type="text" placeholder="Título del anuncio" />
            </div>
          </div>

          <div class="field">
            <label class="label">Texto *</label>
            <div class="control">
              <textarea v-model="form.text" class="textarea" rows="4" placeholder="Descripción del anuncio" />
            </div>
          </div>

          <div class="field">
            <label class="label">Imagen</label>
            <div class="control">
              <input type="file" accept="image/*" @change="onImageChange" />
            </div>
            <div v-if="imagePreview || form.imageUrl" class="mt-3">
              <img :src="imagePreview || form.imageUrl" class="announcement-preview-img" />
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Texto del botón</label>
                <div class="control">
                  <input v-model="form.buttonLabel" class="input" type="text" placeholder="Ej: Ver más" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">URL del botón</label>
                <div class="control">
                  <input v-model="form.buttonUrl" class="input" type="text" placeholder="https://..." />
                </div>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Fecha de inicio *</label>
                <div class="control">
                  <input v-model="form.startDate" class="input" type="date" />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Fecha de fin *</label>
                <div class="control">
                  <input v-model="form.endDate" class="input" type="date" />
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="checkbox">
              <input type="checkbox" v-model="form.isActive" />
              &nbsp;Activo
            </label>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button button-givu" :disabled="saving" @click="submit">
            {{ saving ? 'Guardando...' : 'Guardar' }}
          </button>
          <button class="button" @click="closeFormModal">Cancelar</button>
        </footer>
      </div>
    </div>

    <!-- ── MODAL ESTADÍSTICAS ───────────────────────────── -->
    <div class="modal" :class="{ 'is-active': showStatsModal }">
      <div class="modal-background" @click="closeStatsModal" />
      <div class="modal-card stats-modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Estadísticas — <span class="has-text-weight-normal">{{ statsItem && statsItem.title }}</span>
          </p>
          <button class="delete" @click="closeStatsModal" />
        </header>
        <section class="modal-card-body">
          <div v-if="statsLoading" class="has-text-centered py-6">
            <span>Cargando estadísticas...</span>
          </div>
          <div v-else>
            <div class="columns has-text-centered mb-5">
              <div class="column">
                <div class="stats-card stats-card--opens">
                  <p class="stats-card__number">{{ stats.opens }}</p>
                  <p class="stats-card__label">Abrieron el modal</p>
                </div>
              </div>
              <div class="column">
                <div class="stats-card stats-card--dismisses">
                  <p class="stats-card__number">{{ stats.dismisses }}</p>
                  <p class="stats-card__label">Cerraron el modal</p>
                </div>
              </div>
              <div class="column">
                <div class="stats-card stats-card--rate">
                  <p class="stats-card__number">{{ dismissRate }}%</p>
                  <p class="stats-card__label">Tasa de cierre</p>
                </div>
              </div>
            </div>

            <div v-if="stats.opens > 0 || stats.dismisses > 0">
              <apexchart
                type="bar"
                height="240"
                :options="chartOptions"
                :series="chartSeries"
              />
            </div>
            <div v-else class="has-text-centered has-text-grey py-4">
              <p>Todavía no hay datos para este anuncio.</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="closeStatsModal">Cerrar</button>
        </footer>
      </div>
    </div>

    <!-- ── MODAL CONFIRMAR BORRADO ──────────────────────── -->
    <div class="modal" :class="{ 'is-active': showDeleteModal }">
      <div class="modal-background" @click="showDeleteModal = false" />
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirmar eliminación</p>
          <button class="delete" @click="showDeleteModal = false" />
        </header>
        <section class="modal-card-body">
          <p>¿Estás seguro de que querés eliminar este anuncio? Esta acción no se puede deshacer.</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" :disabled="saving" @click="performDelete">
            {{ saving ? 'Eliminando...' : 'Eliminar' }}
          </button>
          <button class="button" @click="showDeleteModal = false">Cancelar</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const DEFAULT_SIZE = 10

const emptyForm = () => ({
  title: '',
  text: '',
  image: null,
  imageUrl: null,
  buttonLabel: '',
  buttonUrl: '',
  startDate: '',
  endDate: '',
  isActive: true
})

export default {
  name: 'Announcements',
  components: {
    BasePagination: () => import('@/components/BasePagination.vue')
  },
  data () {
    return {
      list: [],
      page: 1,
      pages: 1,
      loading: false,
      showFormModal: false,
      editingId: null,
      saving: false,
      imagePreview: null,
      form: emptyForm(),
      showStatsModal: false,
      statsItem: null,
      statsLoading: false,
      stats: { opens: 0, dismisses: 0 },
      showDeleteModal: false,
      deleteTargetId: null
    }
  },
  computed: {
    dismissRate () {
      if (!this.stats.opens) return 0
      return Math.round((this.stats.dismisses / this.stats.opens) * 100)
    },
    chartSeries () {
      return [{ name: 'Usuarios', data: [this.stats.opens, this.stats.dismisses] }]
    },
    chartOptions () {
      return {
        chart: { type: 'bar', toolbar: { show: false } },
        plotOptions: { bar: { borderRadius: 6, columnWidth: '45%', distributed: true } },
        colors: ['#3273dc', '#48c78e'],
        dataLabels: { enabled: true },
        legend: { show: false },
        xaxis: {
          categories: ['Abrieron', 'Cerraron'],
          labels: { style: { fontSize: '14px', fontWeight: 600 } }
        },
        yaxis: { title: { text: 'Usuarios' }, min: 0 },
        tooltip: { y: { formatter: (val) => `${val} usuario${val !== 1 ? 's' : ''}` } }
      }
    }
  },
  methods: {
    ...mapActions([
      'getAnnouncements',
      'getAnnouncementStats',
      'createAnnouncement',
      'updateAnnouncement',
      'toggleAnnouncementStatus',
      'removeAnnouncement'
    ]),

    formatDate (date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('es-MX')
    },

    async load (page = 1) {
      this.loading = true
      const resp = await this.getAnnouncements({ page, size: DEFAULT_SIZE })
      if (resp) {
        this.list = resp.payload
        this.pages = resp.totalPage
        this.page = page
      }
      this.loading = false
    },

    paginator (page) { this.load(page) },

    openFormModal (item) {
      this.editingId = item ? item.id : null
      this.imagePreview = null
      this.form = item
        ? {
          title: item.title,
          text: item.text,
          image: null,
          imageUrl: item.image || null,
          buttonLabel: item.button_label || '',
          buttonUrl: item.button_url || '',
          startDate: item.start_date ? item.start_date.split('T')[0] : '',
          endDate: item.end_date ? item.end_date.split('T')[0] : '',
          isActive: item.is_active
        }
        : emptyForm()
      this.showFormModal = true
    },

    closeFormModal () {
      this.showFormModal = false
      this.editingId = null
      this.imagePreview = null
      this.form = emptyForm()
    },

    onImageChange (e) {
      const file = e.target.files[0]
      if (!file) return
      this.form.image = { file }
      const reader = new FileReader()
      reader.onload = (ev) => { this.imagePreview = ev.target.result }
      reader.readAsDataURL(file)
    },

    async submit () {
      if (!this.form.title || !this.form.text || !this.form.startDate || !this.form.endDate) {
        this.$store.dispatch('addTemporalNotification', { type: 'danger', message: 'Completá los campos obligatorios (título, texto, fechas)' })
        return
      }
      this.saving = true
      const data = {
        title: this.form.title,
        text: this.form.text,
        image: this.form.image,
        buttonLabel: this.form.buttonLabel,
        buttonUrl: this.form.buttonUrl,
        startDate: this.form.startDate,
        endDate: this.form.endDate,
        isActive: this.form.isActive
      }
      const success = this.editingId
        ? await this.updateAnnouncement({ id: this.editingId, data })
        : await this.createAnnouncement(data)
      this.saving = false
      if (success) { this.closeFormModal(); this.load(this.page) }
    },

    async openStatsModal (item) {
      this.statsItem = item
      this.stats = { opens: 0, dismisses: 0 }
      this.showStatsModal = true
      this.statsLoading = true
      const resp = await this.getAnnouncementStats(item.id)
      if (resp) this.stats = resp.payload
      this.statsLoading = false
    },

    closeStatsModal () {
      this.showStatsModal = false
      this.statsItem = null
    },

    async handleToggleStatus (id) {
      await this.toggleAnnouncementStatus(id)
      this.load(this.page)
    },

    confirmDelete (id) {
      this.deleteTargetId = id
      this.showDeleteModal = true
    },

    async performDelete () {
      this.saving = true
      const success = await this.removeAnnouncement(this.deleteTargetId)
      this.saving = false
      if (success) {
        this.showDeleteModal = false
        this.deleteTargetId = null
        this.load(this.page)
      }
    }
  },
  beforeMount () { this.load() }
}
</script>

<style scoped>
.section { padding: 0 20px 0 20px; }
.announcement-modal-card { width: 700px; max-width: 95vw; }
.stats-modal-card { width: 560px; max-width: 95vw; }
.announcement-preview-img { max-height: 150px; object-fit: contain; border-radius: 4px; }

.stats-card { border-radius: 10px; padding: 20px 12px; }
.stats-card--opens     { background: #eff5ff; }
.stats-card--dismisses { background: #effaf5; }
.stats-card--rate      { background: #fef9eb; }

.stats-card__number { font-size: 2.2rem; font-weight: 700; line-height: 1; margin-bottom: 6px; }
.stats-card--opens     .stats-card__number { color: #3273dc; }
.stats-card--dismisses .stats-card__number { color: #257953; }
.stats-card--rate      .stats-card__number { color: #946c00; }

.stats-card__label { font-size: 0.82rem; color: #666; }
</style>
